import styled from 'styled-components';

declare interface ContentDiv {
  width?: string;
  billetWarning?: boolean;
  confirmData?: boolean;
}

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  z-index: 2;
  align-items: center;

  @media screen and (max-width: 960px) {
    padding-top: 0;
    justify-content: initial;
  }
`;

export const Content = styled.div<ContentDiv>`
  width: ${(props) => props.width || '360px'};
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: ${(props) => (props.confirmData ? '25px' : '32px 32px 40px 32px')};

  @media screen and (max-width: 960px) {
    margin-top: 20px;
    border-radius: 12px 12px 0 0;
    height: fit-content;
    width: 100%;
    z-index: 40;
    padding: 24px 20px;
    bottom: 0;
    position: absolute;
  }
`;

export const Header = styled.div<ContentDiv>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(props) => (props.confirmData ? '20px' : '28px')};

  .close {
    display: none;
    color: ${(props) => props.theme.colors.primary};
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
  }

  .title {
    display: flex;
    align-items: flex-start;
    font-size: 24px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primaryDark1};
  }

  .ghost {
    width: 44px;
    height: 2px;
    background: ${(props) => props.theme.colors.white};
  }

  @media screen and (max-width: 960px) {
    .close {
      display: block;
      padding: 3px 0;
    }

    .title {
      font-size: 20px !important;
    }
  }

  @media screen and (max-width: 360px) {
    .title {
      font-size: 17px !important;
    }
  }
`;

export const Icon = styled.div`
  display: block;
  color: ${(props) => props.theme.colors.gray};

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`;
